import React from 'react';
import PropTypes from 'prop-types';
import ResourceCard from '../ResourceCard';

export const PrincipalTabsContent = ({ title, description }) => (
  <div className="container">
    <section className="my-5">
      <div className="row">
        <div className="col-md-8">
          <h3 className="fs-h2">{title}</h3>
          <p className="fs-p">{description}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row mt-5">
            <div className="col-12 col-md-6">
              <ResourceCard
                headline="Employers, what's in store for 2020"
                date="December 2, 2019"
              />
            </div>

            <div className="col-12 col-md-6">
              <ResourceCard
                headline="Employers, what's in store for 2020"
                date="December 2, 2019"
              />
            </div>

            <div className="col-12 col-md-6">
              <ResourceCard
                headline="Employers, what's in store for 2020"
                date="December 2, 2019"
              />
            </div>

            <div className="col-12 col-md-6">
              <ResourceCard
                headline="Employers, what's in store for 2020"
                date="December 2, 2019"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

PrincipalTabsContent.propTypes = {
  title: PropTypes.any.isRequired,
  description: PropTypes.any.isRequired,
};

export default PrincipalTabsContent;
